
import Vue from 'vue';
import { mapState } from 'vuex';
import TokensSVG from '@/assets/TokensSVG.vue';
import BaseButton from '@/components/base/BaseButton.vue';

export default Vue.extend({
	name: 'PersonalSubscriptionManagement',
	computed: {
		...mapState([
			'user',
		]),
		planName (): string {
			return this._get(this.user, 'clubOffer.name') || 'Current plan';
		},
		isAnnual (): boolean {
			// Canonical annual flag lives on clubInfo (see IsMonthlySwitch.vue / RunnitsSubscriptionCard.vue)
			return !!this._get(this.user, 'clubInfo.isAnnual');
		},
		monthlyTokens (): number {
			return this._get(this.user, 'clubInfo.token.tokens') || 0;
		},
		boardsDisplay (): string {
			if (this._get(this.user, 'clubInfo.limit.unlimitedRunnits')) return 'Unlimited';
			const limit: number = this._get(this.user, 'clubInfo.limit.numRunnitsLimit') || 0;
			return limit > 0 ? `${limit}` : '';
		},
		billingCadenceDisplay (): string {
			return this.isAnnual ? 'Yearly' : 'Monthly';
		},
		// The cadence the user could switch TO (the opposite of what they're on)
		alternateCadence (): string {
			return this.isAnnual ? 'monthly' : 'yearly';
		},
	},
	methods: {
		onManageSubscriptionClick () {
			this.$emit('on-manage-subscription');
		},
		onEditPlan () {
			// All plan changes (tokens, boards, cadence) happen in the plan grid below
			this.$emit('scroll-to-plans');
		},
	},
	components: {
		TokensSVG,
		BaseButton,
	},
});
